import _extends from "../../../../@babel/runtime/helpers/esm/extends.es.js";
import * as React from "react";
import { useGridApiContext } from "../../hooks/utils/useGridApiContext.es.js";
import { getDataGridUtilityClass } from "../../constants/gridClasses.es.js";
import { useGridRootProps } from "../../hooks/utils/useGridRootProps.es.js";
import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import composeClasses from "../../../utils/composeClasses/composeClasses.es.js";
const useUtilityClasses = (ownerState) => {
  const {
    classes,
    open
  } = ownerState;
  const slots = {
    root: ["menuIcon", open && "menuOpen"],
    button: ["menuIconButton"]
  };
  return composeClasses(slots, getDataGridUtilityClass, classes);
};
const ColumnHeaderMenuIcon = /* @__PURE__ */ React.memo((props) => {
  var _rootProps$slotProps, _rootProps$slotProps2;
  const {
    colDef,
    open,
    columnMenuId,
    columnMenuButtonId,
    iconButtonRef
  } = props;
  const apiRef = useGridApiContext();
  const rootProps = useGridRootProps();
  const ownerState = _extends({}, props, {
    classes: rootProps.classes
  });
  const classes = useUtilityClasses(ownerState);
  const handleMenuIconClick = React.useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
    apiRef.current.toggleColumnMenu(colDef.field);
  }, [apiRef, colDef.field]);
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", {
    className: classes.root,
    children: /* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.baseTooltip, _extends({
      title: apiRef.current.getLocaleText("columnMenuLabel"),
      enterDelay: 1e3
    }, (_rootProps$slotProps = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps.baseTooltip, {
      children: /* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.baseIconButton, _extends({
        ref: iconButtonRef,
        tabIndex: -1,
        className: classes.button,
        "aria-label": apiRef.current.getLocaleText("columnMenuLabel"),
        size: "small",
        onClick: handleMenuIconClick,
        "aria-haspopup": "menu",
        "aria-expanded": open,
        "aria-controls": open ? columnMenuId : void 0,
        id: columnMenuButtonId
      }, (_rootProps$slotProps2 = rootProps.slotProps) == null ? void 0 : _rootProps$slotProps2.baseIconButton, {
        children: /* @__PURE__ */ jsxRuntimeExports.jsx(rootProps.slots.columnMenuIcon, {
          fontSize: "small"
        })
      }))
    }))
  });
});
export {
  ColumnHeaderMenuIcon
};
//# sourceMappingURL=ColumnHeaderMenuIcon.es.js.map
